var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45077 4.98471H0.501957C0.299551 4.98471 0.116967 4.86493 0.0388733 4.68091C-0.0391873 4.4969 0.00244946 4.28469 0.144592 4.14272L4.14358 0.1473C4.23791 0.0530373 4.36664 0 4.50098 0H6.47537C6.64929 0 6.81082 0.0887007 6.90229 0.234496C6.99377 0.380258 7.00214 0.562273 6.92444 0.715626L4.89985 4.71105C4.81488 4.87877 4.64099 4.98471 4.45077 4.98471Z",
    fill: "#A0EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4988 4.98471H12.55C12.3598 4.98471 12.1859 4.87877 12.1009 4.71105L10.0763 0.715626C9.99861 0.562273 10.007 0.380258 10.0985 0.234496C10.1899 0.0887334 10.3515 0 10.5254 0H12.4998C12.6341 0 12.7628 0.05307 12.8572 0.1473L16.8562 4.14272C16.9983 4.28472 17.04 4.49697 16.9619 4.68091C16.8838 4.86496 16.7012 4.98471 16.4988 4.98471Z",
    fill: "#73C8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88867 4.47721L6.47457 0H10.5238L13.1017 4.47721H3.88867Z",
    fill: "#73C8F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0062 4.47757L8.04107 13.3053C7.94064 13.5288 8.02102 13.7912 8.23027 13.9226C8.31344 13.9748 8.40701 14.0001 8.49984 14.0001C8.64059 14.0001 8.77961 13.9419 8.87799 13.8311L16.876 4.81598C16.9605 4.72071 17.0028 4.59942 16.9996 4.47754H12.0062V4.47757Z",
    fill: "#41B4E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99362 4.47754H0.000167898C-0.0030196 4.59938 0.0392148 4.7207 0.12375 4.81598L8.12175 13.8311C8.22013 13.9419 8.35919 14.0001 8.4999 14.0001C8.59274 14.0001 8.68634 13.9748 8.76948 13.9226C8.97866 13.7912 9.05908 13.5288 8.95867 13.3053L4.99362 4.47754Z",
    fill: "#41B4E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88867 4.47754L8.04019 13.7057C8.12058 13.8847 8.30054 14.0001 8.49919 14.0001C8.69785 14.0001 8.87781 13.8847 8.95819 13.7057L13.1018 4.47754H3.88867Z",
    fill: "#A0EBFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49609 4.47721H13.1026L10.5246 0H8.49609V4.47721Z",
    fill: "#A0EBFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49805 14.0001C8.6967 14.0001 8.87666 13.8847 8.95705 13.7057L13.1006 4.47754H8.49805V14.0001Z",
    fill: "#73C8F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDiamond);
export default __webpack_public_path__ + "static/media/status-diamond.7ac9312d89b6249018bd141dabd41afb.svg";
export { ForwardRef as ReactComponent };